import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from "../../../common/commonUtil";
import { apiKeyCheck, versionGetApi } from "../../../const";
import { getTempReserveInfo } from "../../../const/RTCC";
import Const from "../../../const/RTCC/Const";
import { useRtoaster } from "../../../hooks/useRtoaster";
import common from "../../../resources/RTCC/js/common/common";
import { Button } from "../../atoms/RTCC/button";
import { Label } from '../../atoms/RTCC/label';
import './../../../resources/RTCC/css/userInput/userInput.css';
import { FooterContainer } from "./footerContainer";

const RtccInputReservationCompleteContainer = (props) => {
    const {
        login,
        toUserInputInfo,
        setToUserInputInfo,
        toUserInputConfirmInfo,
        setToUserInputConfirmInfo,
        searchParam,
        stayInfo,
        reserveInfo,
        onChange,
        onClickOpenCalendarWindow,
        setHeaderCompleteFlg,
        setCancelReserve,
        checkIn,
        checkOut,
        setPassportInfo,
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    // 支払方法
    const [paymentMethod, setPaymentMethod] = useState(toUserInputConfirmInfo.paymentMethod);

    const [roomList, setRoomList] = useState(toUserInputConfirmInfo.roomInfo);
    const [completeFlg, setCompleteFlg] = useState(true);
    const [switchFlg, setSwitchFlg] = useState(false);
    const faildFlg = false;
    // const [domesticFlg, setDomesticFlg] = useState(false);
    const [reserveId, setReserveId] = useState("");

    const history = useHistory();
    const store = useStore();
    let waitCheck = { flag: false };

    // rtoasterタグ生成
    let totalAdultNum = 0;
    let totalChildNum = 0;
    let totalChildAgeList = [];
    stayInfo.forEach(value => {
        totalAdultNum += Number(value.adultNum);
        totalChildNum += Number(value.childNum);
        if (value.ageList?.length) {
            totalChildAgeList.push(value.ageList.join(","));
        }
    })
    const customParam = {
        "hotelid": toUserInputInfo.hotelId,
        "packcd": toUserInputInfo.planId.split("_")?.[1],
        "roomid": toUserInputInfo.planId.split("_")?.[0],
        "packnam": toUserInputInfo.planName,
        "roomname": toUserInputInfo.roomType,
        "riyosyodat": searchParam.searchParam.startDate,
        "riyosaisyudat": searchParam.searchParam.endDate,
        "roomsu": toUserInputInfo.roomNum,
        "adultninzu": totalAdultNum,
        "childninzu": totalChildNum,
        "childage": totalChildAgeList.length ? totalChildAgeList.join(",") : ""
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
        // クレジット決済失敗の場合、予約確認画面にて利用する
        setCancelReserve(reserveId);
        setToUserInputInfo(toUserInputInfo);
        if (toUserInputInfo.completeFlg !== undefined) {
            setCompleteFlg(!toUserInputInfo.completeFlg);
            setHeaderCompleteFlg(!toUserInputInfo.completeFlg);
        } else {
            setCompleteFlg(true);
            setHeaderCompleteFlg(true);
        }

        let count = 0;
        const intervalId = setInterval(() => {
            console.log(count++);
            countUp(waitCheck);
            console.log(waitCheck.flag);
            if (count > 10 || waitCheck.flag) {
                setSwitchFlg(true);
                clearInterval(intervalId);
            }
        }, 1000);
    }, [])

    const countUp = (checkFlg) => {
        common.doPostRef(getTempReserveInfo, { loginId: login.memberCode, completeFlg: "true" }, checkFlg, afterGetTempReserveInfo);
    }

    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useEffect(() => {
        setPassportInfo([])
    }, [])

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    const afterGetTempReserveInfo = (res, checkFlg) => {
        if (res.data && res.data.reserve && res.data.reserve.length == 1) {
            // setDomesticFlg(res.data.reserve[0].domesticFlg);
            //　クレジット決済待ち
            if (res.data.reserve[0].bookingStatus === 'PM00000038') {
                setCompleteFlg(false);
                checkFlg.flag = true;
                console.log("クレジット決済待ち");
                setReserveId(res.data.reserve[0].reserveId);
                //　決済失敗    
            } else if (res.data.reserve[0].bookingStatus === 'PM00000040' || res.data.reserve[0].bookingStatus === 'PM00000042') {
                history.push("/reserve/rtcc/userInputConfirm");
                checkFlg.flag = true;
                console.log("決済失敗または決済取り消し");
                setReserveId(res.data.reserve[0].reserveId);
                //  予約完了の場合
            } else if (res.data.reserve[0].bookingStatus === 'PM00000041') {
                setCompleteFlg(true);
                checkFlg.flag = true;
                console.log("予約完了");
                setReserveId(res.data.reserve[0].reserveId);
                //  空白の場合
            } else if (res.data.reserve[0].bookingStatus === null || res.data.reserve[0].bookingStatus === undefined) {
                setCompleteFlg(false);
                checkFlg.flag = true;
                console.log("空白の場合");
                setReserveId(res.data.reserve[0].reserveId);
            }
            console.log("それ以外");
        }
    }

    // クレジットカード入力画面へ
    const onClickInputCredit = () => {
        roomList.forEach((room) => {
            room.guestInfo.map((guest) => {
                if (guest.representFlg) {
                    document.getElementById("money").value = toUserInputConfirmInfo.paymentPrice;
                    document.getElementById("sendId").value = reserveId;
                    document.getElementById("sendPoint").value = login.memberCode;
                    document.getElementById("telNo").value = guest.telephoneNumber.replaceAll("-", "");
                    document.getElementById("email").value = guest.mailAddress;
                }
            })
        })
        // クレジットカード入力画面遷移
        document.zeusForm.submit();
    }

    // フライト・パスポート登録ボタン押下時
    const onClickCheckInput = (target) => {
        setToUserInputInfo({
            ...toUserInputInfo,
            hotelId: toUserInputInfo.hotelId,
            hotelName: toUserInputInfo.hotelName,
            planId: toUserInputInfo.planId,
            planName: toUserInputInfo.planName,
            planFee: toUserInputInfo.planFee,
            roomNum: toUserInputInfo.roomNum,
            roomType: toUserInputInfo.roomType,
            startDate: toUserInputInfo.startDate,
            endDate: toUserInputInfo.endDate,
            reserveId: reserveId
        });
        if (target == "flight") {
            history.push("/reserve/rtcc/inputFlight");
        } else if (target == "passport") {
            history.push("/reserve/rtcc/inputPassport");
        }
    }

    return (
        <div className="completeInnerWrapper">
            <div className="completeWrapper">
                <div className={switchFlg ? "completeCheckImg" : ""}></div>
                {switchFlg === true ?
                    <>
                        {completeFlg || paymentMethod != "クレジットカード" ?
                            <>
                                <p className="completeTitle">ご予約を承りました</p>
                                <p style={isWideTablet ? styles.completeText2 : styles.completeText}>
                                    ご利用いただき誠にありがとうございます。
                                    <br />予約完了メールをお送りいたしましたので、
                                    <br style={isWideTablet ? styles.deletebr2 : styles.deletebr} />内容をご確認ください。
                                </p>
                            </>
                            :
                            <>
                                {faildFlg ?
                                    <>
                                        <p className="completeTitle">クレジットカードの決済に失敗しました。</p>
                                        <p style={isWideTablet ? styles.completeText2 : styles.completeText}>
                                            もう一度、プランの選択から実施しなおしてください。
                                        </p>
                                    </>
                                    :
                                    null
                                }
                            </>
                        }
                        {completeFlg || paymentMethod != "クレジットカード" ?
                            <>
                                <div className="completeContentsWrapper">
                                    <Label label="ご予約内容" className="completeContentsTitleLabel" />
                                    <div className="reservationInputWrap">
                                        <div className="reservationInput">
                                            <Label
                                                label="施設名"
                                                className="completeTextLabel"
                                            />
                                            <Label
                                                label={toUserInputInfo.hotelName}
                                                className="completeTextLabel2"
                                            />
                                        </div>
                                        <div className="reservationInput">
                                            <Label
                                                label="宿泊プラン名"
                                                className="completeTextLabel"
                                            />
                                            <Label
                                                label={toUserInputInfo.planName}
                                                className="completeTextLabel2"
                                            />
                                        </div>
                                        <div className="reservationInput">
                                            <Label
                                                label="お部屋タイプ"
                                                className="completeTextLabel"
                                            />
                                            <Label
                                                label={toUserInputInfo.roomType}
                                                className="completeTextLabel2"
                                            />
                                        </div>
                                        <div className="reservationInput">
                                            <Label
                                                label="予約番号"
                                                className="completeTextLabel"
                                            />
                                            <Label
                                                label={reserveId}
                                                className="completeTextLabel2"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            null
                        }
                        <div className="btnToReserveCompleteWrapper3">
                            {completeFlg || paymentMethod != "クレジットカード" ?
                                <div className="bookingboxWrap">
                                    <Button buttonText="フライト情報登録" className="btnDispConfirm" onClick={() => onClickCheckInput("flight")} buttonClassName="serachBtnText" />
                                    <Button buttonText="パスポート情報登録" className="btnDispConfirm" onClick={() => onClickCheckInput("passport")} buttonClassName="serachBtnText" />
                                </div>
                                :
                                <div style={{ textAlign: "center" }}>
                                    <p className="completeTitle">外部サイトに移動します。</p>
                                    <p style={isWideTablet ? styles.completeText2 : styles.completeText}>
                                        下記をクリックして、クレジットでのお支払いの手続きをお願い致します。
                                    </p>
                                    <Button
                                        buttonText="クレジットカード入力画面へ"
                                        className="btnInputCredit"
                                        buttonClassName="btnReserveOrCreditTextCenter"
                                        onClick={onClickInputCredit} />
                                </div>
                            }
                        </div>
                        {completeFlg || paymentMethod != "クレジットカード" ?
                            <>
                            </>
                            :
                            <>
                                <div className="completeContentsWrapper">
                                    <Label label="ご予約内容" className="completeContentsTitleLabel" />
                                    <div className="reservationInputWrap">
                                        <div className="reservationInput">
                                            <Label
                                                label="施設名"
                                                className="completeTextLabel"
                                            />
                                            <Label
                                                label={toUserInputInfo.hotelName}
                                                className="completeTextLabel2"
                                            />
                                        </div>
                                        <div className="reservationInput">
                                            <Label
                                                label="宿泊プラン名"
                                                className="completeTextLabel"
                                            />
                                            <Label
                                                label={toUserInputInfo.planName}
                                                className="completeTextLabel2"
                                            />
                                        </div>
                                        <div className="reservationInput">
                                            <Label
                                                label="お部屋タイプ"
                                                className="completeTextLabel"
                                            />
                                            <Label
                                                label={toUserInputInfo.roomType}
                                                className="completeTextLabel2"
                                            />
                                        </div>
                                        <div className="reservationInput">
                                            <Label
                                                label="予約番号"
                                                className="completeTextLabel"
                                            />
                                            <Label
                                                label={reserveId}
                                                className="completeTextLabel2"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </>
                    :
                    null
                }
            </div>
            <div style={styles.footer}>
                <FooterContainer className={"reservationResultFooterBase"} />
            </div>
            <form name="zeusForm" method="POST" action="https://linkpt.cardservice.co.jp/cgi-bin/credit/order.cgi" target="_top">
                <input type="hidden" name="clientip" id="clientIp" value={Const.CLIENT_IP} />
                <input type="hidden" name="money" id="money" value="" />
                <input type="hidden" name="sendid" id="sendId" value="" />
                <input type="hidden" name="sendpoint" id="sendPoint" value="" />
                <input type="hidden" name="telno" id="telNo" value="" />
                <input type="hidden" name="email" id="email" value="" />
                <input type="hidden" name="success_url" id="success_url" value={commonUtil.getDomain() + "/reserve/rtcc/reservationComplete"} />
                <input type="hidden" name="success_str" id="success_str" value={Const.SUCCESS_STR} />
                <input type="hidden" name="failure_url" id="failure_url" value={commonUtil.getDomain() + "/reserve/rtcc/userInputConfirm"} />
                <input type="hidden" name="failure_str" id="failure_str" value={Const.FAILURE_STR} />
            </form>
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        group: state.group,
        room: state.room,
        human: state.human,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        login: state.login,
        kaiinken: state.kaiinken,
        area: state.area,
        country: state.country,
        city: state.city,
        reserveInfo: state.reserveInfo,
        toUserInputInfo: state.toUserInputInfo,
        toUserInputConfirmInfo: state.toUserInputConfirmInfo,
        cancelReserve: state.cancelReserve,
        searchParam: state.searchParam,
        stayInfo: state.stayInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setHuman: (item) => {
            dispatch({ type: "HUMAN", payload: { human: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: { kaiinken: item } })
        },
        setArea: (item) => {
            dispatch({ type: "AREA", payload: { area: item } })
        },
        setCountry: (item) => {
            dispatch({ type: "COUNTRY", payload: { country: item } })
        },
        setCity: (item) => {
            dispatch({ type: "CITY", payload: { city: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
        setToUserInputInfo: (item) => {
            dispatch({ type: "TO_USERINPUT_INFO", payload: { toUserInputInfo: item } })
        },
        setToUserInputConfirmInfo: (item) => {
            dispatch({ type: "TO_USERINPUTCONFIRM_INFO", payload: { toUserInputConfirmInfo: item } })
        },
        setCancelReserve: (item) => {
            dispatch({ type: "CANCEL_RESERVE", payload: { cancelReserve: item } })
        },
        setPassportInfo: (item) => {
            dispatch({ type: "PASSPORT_INFO", payload: { passportInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RtccInputReservationCompleteContainer);
const styles = {
    completeTitle: {
        textAlign: "center",
        fontSize: "1.1em",
    },
    completeText: {
        textAlign: "center",
        fontSize: "small",
        color: "#323232",
        margin: "20px auto 40px auto",
    },
    completeText2: {
        textAlign: "center",
        fontSize: "0.7em",
        color: "#323232",
        margin: "20px auto 40px auto",
    },
    base: {
        background: "rgba(255,255,255,0.9)",
        marginRight: "auto",
        marginLeft: "auto",
        width: "450px",
        padding: "40px",
    },
    base2: {
        background: "rgba(255,255,255,0.9)",
        marginRight: "auto",
        marginLeft: "auto",
        width: "calc(90% - 30px)",
        padding: "30px 15px",
    },
    box: {
        display: "inline-block",
        textAlign: "center",
        margin: "0px auto",
        width: "100%",
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold",
        marginBottom: "25px",
    },
    link: {
        display: "block",
        padding: "30px 3px 3px 3px",
        color: "#6f6f6f",
        textAlign: "center",
        fontSize: "small",
    },
    deletebr: {
        display: "none",
    },
    deletebr2: {
        display: "block",
    },
    btn: {
        display: "flex",
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        width: "60%",
        height: "40px",
        margin: "30px auto",
        border: "none",
        justifyContent: "center",
    },
    btn2: {
        display: "flex",
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        width: "100%",
        height: "40px",
        margin: "30px auto",
        border: "none",
        justifyContent: "center",
    },
    footer: {
        width: "80%",
        padding: "30px 10% 10px",
        whiteSpace: "nowrap",
        color: "white",
        fontWeight: "300",
    },
    useBtn: {
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        display: "inline-block",
        border: "none"
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        marginLeft: "10%",
    },
    breadCrumbArrow: {
        marginRight: "16px",
        marginTop: "0px",
    },
    label: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: "0.9rem",
        letterSpacing: "0.2rem"
    },
    label2: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: 12.6,
        letterSpacing: "0.2rem"
    },
    inputLabel: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: "0.9rem",
        letterSpacing: 3,
    },
    image: {
        width: 200,
        width: "40%",
        margin: "0 auto",
    },
    titleLabel: {
        fontSize: 16,
        letterSpacing: "0.2rem",
        color: "#6f6f6f",
    },
    titleLabel2: {
        fontSize: 14,
        letterSpacing: "0.2rem",
        color: "#6f6f6f",
    },
    form: {
        width: "60%",
        margin: "0px auto 50px",
    },
    line: {
        width: "100%",
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
        margin: "45px auto 0px",
    },
}